'use client'

const TWITTER_ICON = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Twitter_icon_ff1c640904.svg'
const LINKEDIN_ICON = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Linked_In_icon_769968cf58.svg'
const FACEBOOK_ICON = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Facebook_icon_f60eb5e2d3.svg'
const COPY_ICON = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Copy_icon_17f0e140ad.svg'

export type ShareProps = {
  /** URL to share — defaults to current page URL */
  url?: string
  /** Article title used as tweet text */
  title?: string
  /** Override the label. Defaults to "Share this post" */
  label?: string
  className?: string
}

export const Share = ({ url, title, label = 'Share this post', className }: ShareProps) => {
  const getUrl = () => url ?? (typeof window !== 'undefined' ? window.location.href : '')

  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(getUrl())}${title ? `&text=${encodeURIComponent(title)}` : ''}`
  const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(getUrl())}`
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getUrl())}`

  return (
    <div className={`flex items-center gap-[16px] flex-wrap ${className ?? ''}`}>
      <span
        className="[font-size:var(--font-heading-md-size)] [line-height:var(--font-heading-md-line)] [font-weight:600]"
        style={{ color: 'var(--color-text-primary)' }}>
        {label}
      </span>

      <div className="flex items-center gap-[12px]">
        <a
          href={twitterUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on Twitter"
          className="shrink-0 transition-opacity hover:opacity-80">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={TWITTER_ICON} alt="Twitter" width={40} height={40} className="w-[40px] h-[40px]" />
        </a>

        <a
          href={linkedInUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on LinkedIn"
          className="shrink-0 transition-opacity hover:opacity-80">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={LINKEDIN_ICON} alt="LinkedIn" width={40} height={40} className="w-[40px] h-[40px]" />
        </a>

        <a
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Share on Facebook"
          className="shrink-0 transition-opacity hover:opacity-80">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={FACEBOOK_ICON} alt="Facebook" width={40} height={40} className="w-[40px] h-[40px]" />
        </a>

        <button
          type="button"
          aria-label="Copy link"
          className="shrink-0 border-0 bg-transparent p-0 cursor-pointer transition-opacity hover:opacity-80"
          onClick={() => {
            void navigator.clipboard.writeText(getUrl())
          }}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={COPY_ICON} alt="Copy link" width={40} height={40} className="w-[40px] h-[40px]" />
        </button>
      </div>
    </div>
  )
}
